export default __webpack_public_path__ + "static/gdpr-6e8d11453dd1eb48d69c8d35ebf76f9a.svg";